<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
    };
  },

  mounted() {
    // localStorage.setItem("token", '+PQddp7K9/npTSwpE4/SqACwvNg3YRjGRKaTycLgoE/Knh0y0qois5XlZXMfWEG+usaIgPwdioZs+covHubrYKlr+qe+xYa6WHRvPNC0V2U=');
    // this.$dsbridge.callmethod('config', 'h5',data => {
    //   if (data) {
    //     let token = JSON.parse(data).token
    //     localStorage.setItem("token", token);
    //     // this.$store.commit('app/LOGIN',  { token });
    //   }
    // })
  },

};
</script>
<style lang="scss">
html{
  position:absolute;
  top: -0px;
  left: 0;
}
body{
  margin:0;
  padding: 0;
  width: 100vw;
  overflow: hidden;
  // background:#25934B;
}
body *{
  font-size: 16px;
}
#app{
  width: 100vw;
  height: 100vh;
  overflow-y:scroll;
  overflow-x:hidden;
}
</style>
